@if (nps.visible()) {
  <div class="nps-backdrop" role="presentation">
    <section class="nps-modal" role="dialog" aria-modal="true" aria-labelledby="nps-title">
      <button mat-icon-button class="nps-close" type="button" aria-label="Fechar" (click)="nps.dismiss()">
        <mat-icon>close</mat-icon>
      </button>

      <h2 id="nps-title">De 0 a 10, o quanto recomendaria o nosso sistema a outra oficina?</h2>

      <div class="nps-score-grid" aria-label="Selecione uma nota de 0 a 10">
        @for (score of nps.scores; track score) {
          <button
            type="button"
            class="nps-score"
            [class.selected]="nps.selectedScore() === score"
            (click)="nps.selectScore(score)">
            {{ score }}
          </button>
        }
      </div>

      @if (nps.selectedScore() !== null) {
        <mat-form-field appearance="outline" class="nps-comment">
          <mat-label>Comentário opcional</mat-label>
          <textarea
            matInput
            rows="3"
            maxlength="2000"
            [ngModel]="nps.comment()"
            (ngModelChange)="nps.setComment($event)">
          </textarea>
        </mat-form-field>

        <div class="nps-actions">
          <button mat-button type="button" (click)="nps.dismiss()" [disabled]="nps.submitting()">Agora não</button>
          <button mat-flat-button color="primary" type="button" (click)="nps.submit()" [disabled]="nps.submitting()">
            @if (nps.submitting()) {
              <mat-spinner diameter="18"></mat-spinner>
            } @else {
              Enviar
            }
          </button>
        </div>
      }

      <div class="nps-decline">
        <button
          mat-button
          type="button"
          class="nps-decline-button"
          [disabled]="nps.submitting()"
          (click)="nps.declinePermanently()">
          Prefiro não responder
        </button>
      </div>
    </section>
  </div>
}

@if (nps.thankYouVisible()) {
  <div class="nps-backdrop" role="presentation">
    <section class="nps-modal nps-thank-you" role="dialog" aria-modal="true" aria-labelledby="nps-thanks-title">
      <button mat-icon-button class="nps-close" type="button" aria-label="Fechar" (click)="nps.closeThankYou()">
        <mat-icon>close</mat-icon>
      </button>

      <h2 id="nps-thanks-title">Obrigado por sua resposta.</h2>
      <p>Gosta do nosso sistema? Avalie-nos no Google!</p>

      <div class="nps-actions">
        <button mat-button type="button" (click)="nps.closeThankYou()">Fechar</button>
        <button mat-flat-button color="primary" type="button" (click)="openGoogleReview()">
          Avalie-nos no Google
        </button>
      </div>
    </section>
  </div>
}
